<!-- #region NAME -->

<!-- #endregion NAME -->

<!-- #region NAME -->
<header>
  <video class="videoBg" autoplay="true" muted="muted" loop>
    <source
      src="../../assets/video/Contemporary Services Corporation.mp4"
      type="video/mp4"
    />
  </video>
  <div class="headerCopy">
    <div class="headerTitle">
      <h1>
        The <span class="cscGoldText">Leader</span> in Crowd Management.
        <sup>&#174;</sup>
      </h1>
      <h3>
        Let's be part of this
        <span class="cscGoldText">experience</span> together.
      </h3>
    </div>
    <div class="safetyActSection">
      <div class="safetyActCertifiedLogo">
        <img
        loading="lazy"
        src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fsafety_act_certification_200w.png?alt=media&token=62f9f499-f8e0-407c-8c1e-1e7f9e5f0619" alt="Department of Homeland Security Safety Act Certified Logo"/>
      </div>
      <div class="safetyActCopy">
        <p>
          Contemporary Services Corporation (CSC) is recognized worldwide as the
          pioneer, expert and only employee owned company in the crowd
          management field. CSC developed the concept of peer group security
          techniques, and through over five decades of continual refinement and
          evolution, CSC has successfully remained the leader in the crowd
          management and event security industry.
        </p>
      </div>
    </div>
  </div>
  <div class="headerVideo">
    <video class="videoFg" controls="controls" autoplay="true" muted="muted" loop>
      <source
      loading="lazy"
        src="../../assets/video/Contemporary Services Corporation.mp4"
        type="video/mp4"
      />
    </video>
  </div>
</header>
<!-- #endregion NAME -->
